/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportOperationLoanDtoFromFund
 */
export interface MovementOnFundsReportOperationLoanDtoFromFund {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportOperationLoanDtoFromFund
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportOperationLoanDtoFromFund
   */
  name: string;
}

export function MovementOnFundsReportOperationLoanDtoFromFundFromJSON(
  json: any
): MovementOnFundsReportOperationLoanDtoFromFund {
  return MovementOnFundsReportOperationLoanDtoFromFundFromJSONTyped(json, false);
}

export function MovementOnFundsReportOperationLoanDtoFromFundFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportOperationLoanDtoFromFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function MovementOnFundsReportOperationLoanDtoFromFundToJSON(
  value?: MovementOnFundsReportOperationLoanDtoFromFund | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
